<template>
  <div class="solution">
    <div class="cards">
      <div class="title">
        <div class="top">
          <span></span>
          针对以下应用场景
        </div>
        <div class="bottom">我们提供一整套解决方案</div>
      </div>
      <div class="cardList">
        <div class="card" v-for="item in article_list" :key="item.id" @click="gotoDetail(item.id)">
          <div class="img">
            <img :src="item.thumb" alt="" />
          </div>
          <div class="cardTitle">{{item.title}}</div>
          <div class="content">
              {{item.desc}}
          </div>
          <div class="arrow">
            <img src="../assets/images/solution/arrowRight.svg" alt="" />
          </div>
        </div>
      </div>
      <div class="banner" @click="gotoLxwm()">
        <img src="../assets/images/solution/icon04.png" alt="" />
        <div class="text">更多需求，请联系我们，专业团队为您服务...</div>
        <div class="bannerBtn"></div>
      </div>
    </div>
    <div class="introductions">
      <div class="left">
        <div class="introTitle">
          <span></span>
          Customer Feedbacks
        </div>
        <div class="introContent">合作过的客户如是说...</div>
        <div class="introArrow">
          <img src="../assets/images/solution/arrowLeft.svg" alt="" />
          <img src="../assets/images/solution/arrowRight.svg" alt="" />
        </div>
      </div>
      <div class="right">
        <div class="introCard">
          <div class="cardTop">
            <div class="imgLeft">
              <img src="../assets/images/solution/customer01.png" alt="" />
            </div>
            <div class="name">
              <div class="nameTop">武汉某三甲医院</div>
              <div class="nameBottom">后勤科主任</div>
            </div>
            <div class="imgRight">
              <img src="../assets/images/solution/quoteRight.svg" alt="" />
            </div>
          </div>
          <div class="cardBottom">
            医院的系统越来越多，数据信息分散在好几处，后勤科的人员经常需要记录好几个账号，有的业务甚至要在几个软件之间切换处理，非常伤脑筋。我们定制的这个一站式管理平台，主要目的也是对我们的业务和数据做一个整合，将管理工作化繁为简，而它确实也达到了我们的要求，业务之间联动也做的非常好。
          </div>
        </div>
        <div class="introCard">
          <div class="cardTop">
            <div class="imgLeft">
              <img src="../assets/images/solution/customer02.png" alt="" />
            </div>
            <div class="name">
              <div class="nameTop">上海某大型物业集团</div>
              <div class="nameBottom">工程设备部经理</div>
            </div>
            <div class="imgRight">
              <img src="../assets/images/solution/quoteRight.svg" alt="" />
            </div>
          </div>
          <div class="cardBottom">
            系统界面确实很漂亮，并且针对我们很多特殊的需求场景做了定制化，同时在保证功能的前提下为我们简化了操作，使软件简单易上手。我们的维修师傅能在手机上很方便地查看设备情况和响应工单任务，设备如果出了故障也能很快推送告警消息，使用两年多了感觉对我们物业运营的效率帮助很大。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "solution",
  data() {
    return {
        article_list:[]
    };
  },
    created() {
        this.getarticlelist();
    },
  methods: {
      getarticlelist() {
          let self = this;
          var url = "index/article_list?cate_id=6";
          self.$axios.get(self.api.apiurl + url).then(function (res) {
              self.article_list = res.data.data.list;
          })
      },
      gotoDetail(val) {
          //this.$router.push(`/service/detail/${val}`);
      },
      gotoLxwm() {
          this.$router.push(`/lxwm`);
      },
  },
};
</script>

<style lang="scss" scoped>
.solution {
  width: 192rem;

  .cards {
    background-color: #eef3f7;
    height: 145rem;
    overflow: hidden;

    .title {
      width: 100%;
      height: 10rem;
      padding: 5rem;
      text-align: center;

      .top {
        margin: 0 auto;
        font-size: 1.6rem;
        color: #b3b4b9;
        padding-left: 5rem;
        height: 3rem;
        line-height: 3rem;
        position: relative;

        span {
          position: absolute;
          display: inline-block;
          width: 1.5rem;
          height: 0;
          left: 46%;
          top: 1.4rem;
          border-top: 0.3rem solid #19d6ae;
        }
      }

      .bottom {
        margin: 0 auto;
        padding: 2rem 0;
        font-size: 4rem;
        color: #404447;
      }
    }

    .cardList {
      width: 145rem;

      margin: 0 auto;
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .card {
        width: 45rem;
        height: 64rem;
        background-color: #fff;
        border-radius: 1rem;
        text-align: center;
        transition: all 1s linear;
        cursor: pointer;

        .img {
          width: 14rem;
          height: 14rem;
          padding: 5rem 0 0 15.5rem;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .cardTitle {
          font-size: 2.4rem;
          color: black;
          font-weight: 400;
          padding: 3rem 0;
        }

        .content {
          font-size: 1.6rem;
          color: #9a99a0;
          padding: 0 4rem 2rem 4rem;
          line-height: 2;
          height: 22rem;
          transition: all 1s linear;
        }

        .arrow {
          width: 6rem;
          height: 7rem;
          cursor: pointer;
          padding: 0 0 0 19.5rem;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }

      .card:hover {
        transition: 1s;

        .content {
          transition: 1s;
          color: black;
        }
      }
    }

    .banner {
      position: relative;
      margin-top: -9rem;

      img {
        width: 100%;
      }

      .text {
        position: absolute;
        left: 11rem;
        top: 35rem;
        font-size: 5rem;
        color: #fff;
        width: 75rem;
        text-align: left;
        font-weight: 700;
      }

      .text2 {
        position: absolute;
        right: 55rem;
        top: 29.5rem;
        color: rgba(0, 0, 0, 0.7);
        font-size: 3.6rem;
        width: 22rem;
      }

      .bannerBtn {
        position: absolute;
        left: 11rem;
        top: 52rem;
        width: 32rem;
        height: 9rem;
        cursor: pointer;
      }
    }
  }

  .introductions {
    width: 100%;
    height: 51rem;
    z-index: 99;
    background-color: #eef3f7;
    padding: 5rem 0;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;

    .left {
      text-align: left;
      width: 32rem;
      padding-left: 16rem;
      padding-right: 8rem;

      .introTitle {
        color: #838389;
        position: relative;
        padding-left: 2rem;
        font-size: 2rem;

        span {
          position: absolute;
          left: 0.2rem;
          top: 1rem;
          width: 1.2rem;
          height: 0;
          border-top: 0.3rem solid #2cd5b8;
        }
      }

      .introContent {
        color: black;
        font-size: 4.6rem;
        font-weight: 500;
        line-height: 2;
        margin-top: 3rem;
      }

      .introArrow {
        margin-top: 8rem;

        img {
          width: 5rem;
          height: 5rem;
          cursor: pointer;
        }
      }
    }

    .right {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;

      .introCard {
        width: 62rem;
        height: 49rem;
        padding: 8rem;
        box-sizing: border-box;
        margin-right: 6rem;
        border-radius: 1rem;
        background-color: #fff;
        cursor: pointer;
        transition: all 1s linear;

        .cardTop {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;

          .imgLeft {
            width: 8rem;
            height: 8rem;
            overflow: hidden;
            border-radius: 4rem;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .name {
            margin-left: 3rem;
            width: 24rem;

            .nameTop {
              font-size: 2.4rem;
              color: black;
              text-align: left;
            }

            .nameBottom {
              font-size: 2rem;
              color: #4f9df7;
              text-align: left;
            }
          }

          .imgRight {
            width: 6rem;
            height: 6rem;
            margin-left: 5rem;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }

        .cardBottom {
          padding-top: 2rem;
          font-size: 2rem;
          color: #a4a3a8;
          line-height: 1.8;
          text-align: left;
          transition: all 1s linear;
        }
      }

      .introCard:hover {
        transition: 1s;
        background-color: rgba(255, 255, 255, 0.8);

        .cardBottom {
          transition: 1s;
          color: #404447;
        }
      }
    }
  }
}

@media screen and (max-width: 750px) {

.solution{
  .cards{
    height: 260rem;
    .title{
    height: 16rem;
    .bottom{
      font-size: 9rem;
    }
  }

  .cardList{
      width: 180rem;

      .card{
        width: 59rem;
        height: 170rem;
        .img{
          width: 18rem;
          height: 18rem;
          padding: 5rem 0 0 20.5rem;
        }
        .arrow{
          display: none;
        }
      }
    }



  }
  .introductions{
    height: 125rem;
    .left{
      display: none;
    }
    .right{
      .introCard{
        width: 93rem;
        height: 110rem;
        .cardTop{
          .imgRight{
             display: none;

          }
          .name{
              width: 56rem;
             }
        }
      }
    }
  }

}
}

// @media screen and (max-width: 750px) {

// .solution{
//   .cards{
//     height: 220rem;
//     .title{
//     height: 16rem;
//     .bottom{
//       font-size: 9rem;
//     }
//   }

//   .cardList{
//       width: 180rem;

//       .card{
//         width: 59rem;
//         height: 120rem;
//         .img{
//           width: 18rem;
//           height: 18rem;
//           padding: 5rem 0 0 20.5rem;
//         }
//         .arrow{
//           display: none;
//         }
//       }
//     }



//   }
//   .introductions{
//     height: 85rem;
//     .left{
//       display: none;
//     }
//     .right{
//       .introCard{
//         width: 93rem;
//         height: 80rem;
//         .cardTop{
//           .imgRight{
//              display: none;

//           }
//           .name{
//               width: 56rem;
//              }
//         }
//       }
//     }
//   }

// }
// }

@media screen and (max-device-width: 750px) {
    .cards{
        height: auto !important;
        .title{height: 20rem !important;}
        .cardList{
            display: block !important;
            height: auto !important;
            .card{
                width: 100% !important;
                height: auto !important;
                margin-bottom: 8rem;
                .img{
                    float: left;
                    padding:5rem 0 !important;
                    width: 25% !important;
                    img{width: 30rem !important; height: 30rem !important;}
                }
                .cardTitle{font-size: 8rem !important; text-align: left;}
                .content{overflow: hidden; text-align: left; padding:0 !important; font-size: 7rem !important; line-height: 1.5 !important;}
            }
        }
    }
    .introCard{
        .cardBottom{height:80rem !important; overflow: hidden !important;}
    }
}
</style>
